import useButtonLoader from "common/UseButtonLoader";
import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resendOtp, verifyOtpApi } from "services/auth";
import { setPersonalInfo } from "store/slices/userDataStore";
import { toastMessage } from "utils/toastMessage";

const OTPComponent = ({ setSteps, data, setData }) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Verify");
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const [resendDisabled, setResendDisabled] = useState(true);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(59);
  const dispatch = useDispatch();
  const verifyOtpHandler = async () => {
    try {
      if (otp.length >= 4) {
        setButtonLoader(true);
        const res = await verifyOtpApi({ ...data, otp: otp });
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", "loginToDashboard");
          setData(res?.data?.data?.user);
          console.log(res?.data?.data?.user, "es?.data?.data?.user")
          const savePersonalInfo = {
            ...res?.data?.data?.user,
            isAdmin: res?.data?.data?.user.toString(),
          };
          localStorage.setItem("sessionExpire", new Date());
          navigate("/dashboard");
          localStorage.setItem("token", res?.data?.data?.token);
          localStorage.setItem(
            "admin",
            JSON.stringify(savePersonalInfo)
          );
          localStorage.setItem(
            "adminInfo",
            JSON.stringify(data)
          );
          dispatch(setPersonalInfo({ personalInfo: savePersonalInfo }));
        } else {
          toastMessage(res?.data?.message, "error", "loginToDashboard");
        }
      } else {
        toastMessage("Invalid OTp", "error", "invalidOtp");
      }
    } catch (e) {
      console.log("error:", e.message);
    } finally {
      setButtonLoader(false);
    }
  };
  const resendOtpHandler = async () => {
    try {
      setResendDisabled(true);
      setMinutes(0);
      setSeconds(59);
      const reqData = {
        email: data?.email,
      };
      const res = await resendOtp(reqData);
      if (res?.data?.status === 200) {
        toastMessage(res?.data?.message, "success", "OtpSend");
      } else {
        toastMessage(res?.data?.message, "error", "OtpSend");
      }
    } catch (e) {
      console.log("error:", e.message);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
          setResendDisabled(false);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [minutes, seconds]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      verifyOtpHandler();
    }
  };
  return (
    <>
      <form className="otp_section">
        <div className="form_title">
          <h2>Verify OTP</h2>
          <p>Please enter the OTP SENT to {`+91 ${data?.mobile}`}</p>
        </div>

        <div className="content">
          <div className="otp_wrap">
            <OTPInput
              inputStyle={"form-control input"}
              inputType="tel"
              value={otp}
              onChange={setOtp}
              onKeyPress={handleKeyPress}

              numInputs={4}
              renderInput={(props) => <input {...props} />}
            />
          </div>

          <div className="resend_button">
            <p>
              {/* Resend OTP in <b>00:56</b> */}
              Resend OTP in{" "}
              <b>
                {minutes < 10 ? `0${minutes}` : minutes}:
                {seconds < 10 ? `0${seconds}` : seconds}
              </b>
            </p>
            <button
              type="button"
              disabled={resendDisabled}
              onClick={resendOtpHandler}
            >
              Resend OTP
            </button>
          </div>
          {/* {seconds > 0 || minutes > 0 ? (
            <p>
              Time Remaining: 
            </p>
          ) : (
            <p>Didn't recieve code?</p>
          )} */}
          <div className="button_wrap button_right">
            <button
              type="button"
              className="button w-100"
              ref={buttonLoader}
              onClick={verifyOtpHandler}
            >
              Verify
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default OTPComponent;
